@use '@fukuri-admins/ui/layout' as *;

.radioWrapper {
  display: flex;
  flex-direction: column;
  gap: spacing('2');
}

.radioRow {
  display: flex;
  align-items: center;
  gap: spacing('8');
}

.radio {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  // ラジオボタンは16pxで統一
  width: 16px;
  height: 16px;

  background: background('Primary');
  border: 1px solid border('Quaternary');
  border-radius: borderRadius('full');
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px border('Focus');
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
}

.radioIndicator {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 6px;
  height: 6px;

  &::after {
    content: '';
    display: block;
    width: 6px;
    height: 6px;
    border-radius: borderRadius('md');
    border: 1px solid border('Gray_Darken');
    background: background('Gray_Darken');
  }
}

// Medium サイズ（太字）
.radioLabelMedium {
  @include typography('Jp/14_W6');
  color: text('High');
  cursor: pointer;
}

.radioDescriptionMedium {
  @include typography('Jp/12_W3');
  color: text('Low');
  // ラジオボタン(16px) + gap(8px) 分インデント
  padding-left: 24px;
}

// Regular サイズ（通常）
.radioLabelRegular {
  @include typography('Jp/14_W3');
  color: text('High');
  cursor: pointer;
}

.radioDescriptionRegular {
  @include typography('Jp/12_W3');
  color: text('Low');
  // ラジオボタン(16px) + gap(8px) 分インデント
  padding-left: 24px;
}
